import React from 'react';
import '../css/DamagePolicy.css';

const DamagePolicy = () => {
  return (
    <div className="policy-container">
      <div className="policy-card">
        {/* Header */}
        <div className="policy-header">
          <div className="policy-icon">🛡️</div>
          <h2>Damage & Loss Policy</h2>
          <p className="policy-subtitle">
            Please review our standard terms regarding item care, processing, and liability.
          </p>
        </div>

        {/* Policy Content List */}
        <div className="policy-list">
          <div className="policy-item">
            <span className="policy-number">1</span>
            <div className="policy-content">
              <h4>Uncollected Items</h4>
              <p>
                Items not collected within 31 days of notification may be treated as abandoned.
              </p>
            </div>
          </div>

          <div className="policy-item">
            <span className="policy-number">2</span>
            <div className="policy-content">
              <h4>Valuables</h4>
              <p>
                Customers are responsible for removing all valuables and personal belongings from pockets before handover.
              </p>
            </div>
          </div>

          <div className="policy-item">
            <span className="policy-number">3</span>
            <div className="policy-content">
              <h4>Stains & Colours</h4>
              <p>
                We take utmost care with stain removal, but results and colour retention cannot be guaranteed.
              </p>
            </div>
          </div>

          <div className="policy-item highlight-item">
            <span className="policy-number">4</span>
            <div className="policy-content">
              <h4>Loss or Damage</h4>
              <p>
                Confirmed loss or damage during processing will be compensated up to <strong>5× the applicable service charge</strong>.
              </p>
            </div>
          </div>

          <div className="policy-item">
            <span className="policy-number">5</span>
            <div className="policy-content">
              <h4>Pre-existing Damage</h4>
              <p>
                We are not responsible for pre-existing damage, normal wear, or deterioration due to the condition of the garment.
              </p>
            </div>
          </div>

          <div className="policy-item">
            <span className="policy-number">6</span>
            <div className="policy-content">
              <h4>Acceptance</h4>
              <p>
                Placing an order with Mr White confirms acceptance of this Damage & Loss Policy.
              </p>
            </div>
          </div>
        </div>

        {/* Footer Note */}
        <div className="policy-footer">
          <p>
            Thank you for choosing <strong>Mr White Laundry</strong>. If you have any questions, feel free to contact our customer support team.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DamagePolicy;